module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-300-book-italic-ef900117c4f977b7d1a559fefd42f187.woff2";